module.exports = require("asn1.js");